import React from 'react';

export default function Testimonials(){
  const items = [
    { id:1, name:'Chipo M.', role:'Frontend Engineer', text:'Talent Link helped me find my dream job quickly.' },
    { id:2, name:'Tendai R.', role:'HR Manager', text:'Great candidates and an easy process to post roles.' },
    { id:3, name:'Simba K.', role:'Data Analyst', text:'The platform matched me with roles that fit my skills.' }
  ];

  return (
    <section className="py-12 px-4 bg-background-offwhite">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-2xl font-bold mb-6">What People Say</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map(t => (
            <div key={t.id} className="bg-white p-6 rounded-lg shadow">
              <p className="text-gray-700 mb-4">“{t.text}”</p>
              <div className="font-semibold">{t.name}</div>
              <div className="text-sm text-gray-500">{t.role}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
